import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setHtmlContent,
  setHtmlContentSH,
} from "../../features/redux/statusFileSlice";
import {
  fetchOrderFile,
  fetchOrderSHFile,
} from "../../features/action/fetchStatusFile";
import { comment, commentTrueBlue, img, notPay, pay, sh, so } from "../../util/icon";
import { ShowOrder } from "../common/ShowOrder";
import { ShowImgStatus } from "../common/ShowImgStatus";
import { getImageStatusFileFetch } from "../../features/action/fetchImage";
import { place } from "./main";
import { ShowOrderSH } from "../common/ShowOrderSH";
import { ShowComment } from "../common/ShowComment";

export const Storage = ({ i }) => {
  const { imgStatus } = useSelector((state) => state.imageFile);
  const { htmlContent } = useSelector((state) => state.orderFile);
  const [showOrder, setShowOrder] = useState(false);
  const [showOrderSH, setShowOrderSH] = useState(false);
  const [showItems, setShowItems] = useState(false);
  const [showComment, setShowComment] = useState(false);
  const dispatch = useDispatch();
  const [isFlipped, setIsFlipped] = useState(false);
  const [isFlipped2, setIsFlipped2] = useState(false);

console.log("Storage", i);

  const handleOpenText = (e) => {
    e.stopPropagation();
    setIsFlipped(!isFlipped);
  };

  const handleOpenOrder = (e, numOrder) => {
    e.stopPropagation();
    dispatch(setHtmlContent(null));
    dispatch(fetchOrderFile(numOrder));
    setShowOrder(true);
  };

  const handleOpenOrderSH = (e, tableSH) => {
    console.log("handleOpenOrderSH", tableSH);
    e.stopPropagation();
    dispatch(setHtmlContentSH(null));
    dispatch(fetchOrderSHFile(tableSH));
    setShowOrderSH(true);
  };

  const handleOpenImage = (e, url) => {
    e.stopPropagation();
    dispatch(getImageStatusFileFetch(url));
    imgStatus && setShowItems(true);
  };

  const handleOpenComment = (e) => {
    e.stopPropagation();
    setShowComment(true);
  };

  return (
    <>
      <div className="flex flex-row w-[384px] ">
        <div className="w-[304px] content-center">
          <div
            className="relative w-full h-full cursor-pointer"
            onClick={handleOpenText}
            style={{ perspective: "1000px" }}
          >
            <div
              className="relative w-full h-full transition-transform duration-500"
              style={{
                transformStyle: "preserve-3d",
                transform: isFlipped ? "rotateX(180deg)" : "rotateX(0deg)",
              }}
            >
              {/* Передняя сторона - номер заказа */}
              <div
                className={`absolute w-full h-full flex items-center justify-center ${"bg-[#00599D]"}`}
                style={{ backfaceVisibility: "hidden" }}
              >
                <div className="flex flex-row justify-center items-center ">
                  <p className="font-rubik font-medium text-[16px] leading-tight tracking-wide-5 text-[#65ADE3] px-1">
                    {i.order.slice(0, 6)}
                  </p>
                  <p className="font-rubik font-black text-[40px] leading-tight tracking-wide-5 text-[#FFFFFF] px-1">
                    {i.order.slice(6)}
                  </p>
                </div>
              </div>
              {/* Задняя сторона - текст клиента */}
              <div
                className={`absolute w-full h-full flex text-left items-center justify-center p-2 ${"bg-[#00599D]"}`}
                style={{
                  backfaceVisibility: "hidden",
                  transform: "rotateX(180deg)",
                }}
              >
                <div className="flex w-full justify-evenly content-center items-center">
                  {/* ---------------------------------------Show HTML SO-------------------------------------------------- */}
                  <button
                    className="text-[2vw] w-[11%] content-center "
                    onClick={(e) => handleOpenOrder(e, i.order)}
                  >
                    {so}
                  </button>
                  {/* ---------------------------------------Show HTML SH-------------------------------------------------- */}
                  {i.tableSH && (
                    <button
                      className="text-[2vw] w-[11%] content-center "
                      onClick={(e) => handleOpenOrderSH(e, i.tableSH.orderSH)}
                    >
                      {sh}
                    </button>
                  )}
                  {/* ---------------------------------------Image-------------------------------------------------- */}
                  {i.img && (
                    <button
                      className="text-[2vw]  w-[11%] content-center "
                      onClick={(e) => handleOpenImage(e, i.img)}
                    >
                      {img}
                    </button>
                  )}
                  {/* ---------------------------------------Comment-------------------------------------------------- */}
                  <div
                    className="text-[2vw]  w-[11%] content-center  "
                    onClick={(e) => handleOpenComment(e, i.comment)}
                  >
                    {/* { i.comment ? comment : commentTrue } */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

       
          <button
            className="flex w-[18%] bg-[#00599D] items-center justify-center"
            onClick={(e) => handleOpenComment(e)}
          >
            {i.comment?.length > 0 ? comment : commentTrueBlue}
          </button>
       
        {showOrder && <ShowOrder setShowOrder={setShowOrder} />}
        {showOrderSH && <ShowOrderSH setShowOrderSH={setShowOrderSH} />}
        {showComment && (
          <ShowComment
            setShowComment={setShowComment}
            statusComment={i.comment}
            order={i.order}
          />
        )}
        {showItems && (
          <ShowImgStatus
            url={imgStatus}
            setShowItems={setShowItems}
            loadingImage={imgStatus}
          />
        )}
      </div>
      <div
        className="flex w-[32.58%] items-center"
        style={{ perspective: "1000px" }}
      >
        <div
          className="relative w-full h-full transition-transform duration-500"
          style={{
            transformStyle: "preserve-3d",
            transform: isFlipped2 ? "rotateX(180deg)" : "rotateX(0deg)",
          }}
        >
          {/* Передняя сторона */}
          <div
            className="absolute w-full h-full flex items-center"
            style={{ backfaceVisibility: "hidden" }}
          >
            <div className="flex w-[388px] items-center">
              <div className="px-5"> {place(i.numberLine)}</div>
              <span className="text-[#979797] font-rubik font-bold text-xl leading-[100%] tracking-[0.05em] text-center align-middle">
                {i.numberPlace}
              </span>
            </div>
            <div
              className="w-[112px] flex items-center justify-center cursor-pointer"
              onClick={() => setIsFlipped2(true)}
            >
              <div className="w-[24px] h-[24px] rounded-[50%] bg-[#739D00]"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
